import { render, staticRenderFns } from "./VideoType.vue?vue&type=template&id=3d116de9&scoped=true"
import script from "./VideoType.vue?vue&type=script&lang=js"
export * from "./VideoType.vue?vue&type=script&lang=js"
import style0 from "./VideoType.vue?vue&type=style&index=0&id=3d116de9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d116de9",
  null
  
)

export default component.exports